import ApiBaseURL from "../../utils/config";
import ApiList from "../../utils/apiList";
import { GetUserAccessToken } from "../../utils/helper";

export const RequiredDetailsForDOFE = async (formData) => {
  const response = await ApiBaseURL.post(ApiList.apiGetRequiredDetailsForDOFE, formData, {
    headers: {
      Authorization: "Bearer " + GetUserAccessToken(),
      "Access-Control-Allow-Origin": "*",
      "Content-type": "application/json; charset=UTF-8",
    },
  });
  return response.data;
};

export const apiGetCustomerDetailsByPassportNo = async (formData) => {
  const response = await ApiBaseURL.post(ApiList.apiGetCustomerDetailsByPassportNo, formData, {
    headers: {
      Authorization: "Bearer " + GetUserAccessToken(),
      "Access-Control-Allow-Origin": "*",
      "Content-type": "application/json; charset=UTF-8",
    },
  });
  return response.data;
};

export const apiSaveFECustomerDetails = async (formData) => {
  const response = await ApiBaseURL.post(ApiList.apiSaveFECustomerDetails, formData, {
    headers: {
      Authorization: "Bearer " + GetUserAccessToken(),
      "Access-Control-Allow-Origin": "*",
      "Content-type": "application/json; charset=UTF-8",
    },
  });
  return response.data;
};

export const apiProceedFEPolicyGeneration = async (formData) => {
  const response = await ApiBaseURL.post(ApiList.apiProceedFEPolicyGeneration, formData, {
    headers: {
      Authorization: "Bearer " + GetUserAccessToken(),
      "Access-Control-Allow-Origin": "*",
      "Content-type": "application/json; charset=UTF-8",
    },
  });
  return response.data;
};

export const apiGetDetailsByRegisterNo = async (formData) => {
  const response = await ApiBaseURL.post(ApiList.apiGetDetailsByRegisterNo, formData, {
    headers: {
      Authorization: "Bearer " + GetUserAccessToken(),
      "Access-Control-Allow-Origin": "*",
      "Content-type": "application/json; charset=UTF-8",
    },
  });
  return response.data;
};

export const apiDOFEGetGridList = async (formData) => {
  const response = await ApiBaseURL.post(ApiList.apiDOFEGetGridList, formData, {
    headers: {
      Authorization: "Bearer " + GetUserAccessToken(),
      "Access-Control-Allow-Origin": "*",
      "Content-type": "application/json; charset=UTF-8",
    },
  });
  return response.data;
};
